/**
 * Sign Up Page
 */
import React from 'react';
import { SignUpForm } from '../components/auth/SignUpForm';
import logo from '../assets/new-logo-wide.png';

export const SignUpPage: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-black p-4">
      <div className="flex flex-col items-center mb-6">
        <img src={logo} alt="Recon logo" className="w-48 mb-2" />
      </div>
      <SignUpForm />
    </div>
  );
};
